//@flow

import React from "react"

import { ProgressItemLabel } from "../UI"

import type { Unit } from "../types"
import type { Metric } from "../../Shared/AQILegend"

const units: { [Metric]: Unit } = {
  pm2_5: "ug/m3",
  pm10: "ug/m3",
  o3: "ppb"
}

const MetricLabel = ({
  metric,
  Wrapper,
  innerRef
}: {
  metric: Metric,
  Wrapper?: Class<React.Component<*>>,
  innerRef?: (el: ?HTMLElement) => any
}) => {
  const WrapperTag = Wrapper ? Wrapper : ProgressItemLabel
  return units[metric] === "ug/m3" ? (
    <WrapperTag innerRef={innerRef}>
      μg/m<sup>3</sup>
    </WrapperTag>
  ) : (
    <WrapperTag innerRef={innerRef}>{units[metric]}</WrapperTag>
  )
}

export default MetricLabel



// WEBPACK FOOTER //
// ./src/Kiosk/CurrentAirQualityView/ForecastMetric/MetricLabel.js